export default {
      id: "github-usage",
      viewBox: "0 0 496 512",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#github",
      toString: function () {
        return this.url;
      }
    }